import React from 'react';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Diseño UX/UI",
      description: "Creación de interfaces intuitivas y experiencias de usuario optimizadas"
    },
    {
      id: 2,
      title: "Diseño Gráfico",
      description: "Identidad visual, branding y materiales gráficos profesionales"
    },
    {
      id: 3,
      title: "Frontend Developer",
      description: "Desarrollo de aplicaciones web modernas con React y tecnologías actuales"
    }
  ];

  return (
    <section id="servicios" className="services">
      <div className="container">
        <h2>Servicios</h2>
        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;